/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGOpenCode1(props) {
  return (
    <svg width={58} height={70} viewBox="0 0 58 70" {...props}>
      <g>
        <path
          d="M37.898 1h-34.888c-1.11 0-2.01.899-2.01 1.992v63.183c0 1.1.892 1.992 2.003 1.992h51.342c1.106 0 2.003-.89 2.003-2.006v-46.843l-18.449-18.318z"
          id="Combined-Shape"
          fill="#E6F5FB"
        />
        <path
          d="M48.914 11.938l7.433 7.381v46.843c0 1.116-.897 2.006-2.003 2.006h-51.342c-1.111 0-2.003-.892-2.003-1.992v-4.114h45.657c1.106 0 2.007-.899 2.013-1.992l.244-48.132z"
          id="Combined-Shape"
          fill="#CBECF9"
        />
        <path
          d="M56.347 19.318h-16.439c-1.11 0-2.009-.896-2.009-1.995v-16.323"
          fill="#97D9F2"
        />
        <path
          d="M26.65 43.602v1.851h-1.464c-1.62 0-2.705-.239-3.255-.717-.55-.478-.825-1.431-.825-2.859v-2.083c0-.975-.174-1.649-.522-2.02-.348-.371-.978-.557-1.888-.557h-.605v-1.851h.605c.911 0 1.54-.184 1.888-.552.348-.368.522-1.043.522-2.025v-2.083c0-1.428.275-2.379.825-2.854.55-.475 1.635-.712 3.255-.712h1.464v1.841h-1.2c-.677 0-1.129.136-1.356.407-.228.271-.342.869-.342 1.793v2.025c0 1.066-.159 1.815-.478 2.248-.319.433-.888.711-1.708.833.82.136 1.389.423 1.708.862.319.439.478 1.189.478 2.248v1.986c0 .93.114 1.533.342 1.807.228.275.68.412 1.356.412h1.2zm3.513 0h1.181c.677 0 1.132-.139 1.366-.417.234-.278.351-.879.351-1.802v-1.986c0-1.059.159-1.809.478-2.248.319-.439.885-.727 1.698-.862-.82-.123-1.387-.401-1.703-.833-.316-.433-.473-1.182-.473-2.248v-2.025c0-.911-.115-1.505-.346-1.783-.231-.278-.688-.417-1.371-.417h-1.181v-1.841h1.464c1.613 0 2.692.237 3.235.712.543.475.815 1.426.815 2.854v2.083c0 .975.177 1.649.532 2.02.355.371.991.557 1.908.557h.605v1.851h-.605c-.917 0-1.553.187-1.908.562-.355.375-.532 1.047-.532 2.015v2.083c0 1.428-.272 2.38-.815 2.859-.543.478-1.622.717-3.235.717h-1.464v-1.851z"
          fill="#97D9F2"
        />
        <path
          d="M38.31 0l19.037 18.902v47.259c0 1.666-1.342 3.006-3.003 3.006h-51.342c-1.661 0-3.003-1.337-3.003-2.992v-63.183c0-1.649 1.351-2.992 3.01-2.992h35.3zm-35.3 2c-.557 0-1.01.45-1.01.992v63.183c0 .549.445.992 1.003.992h51.342c.557 0 1.003-.445 1.003-1.006v-46.427l-17.861-17.735h-34.476zm53.337 16.318v2h-16.439c-1.66 0-3.009-1.341-3.009-2.995v-16.323h2v16.323c0 .547.451.995 1.009.995h16.439z"
          fill="#00A1DE"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGOpenCode1.js